import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { Question, Questionnaire } from 'src/app/shared/models/questionnaire.model';

@Component({
    selector: 'app-preview-questionnaire',
    templateUrl: './preview-questionnaire.component.html',
    styleUrl: './preview-questionnaire.component.scss',
    standalone: false
})
export class PreviewQuestionnaireComponent {
	@ViewChild('previewQuestionnaireModal') previewQuestionnaireModal!: TemplateRef<any>;

	questionnaire!: Questionnaire;
	loading = true;

	showDesc = false;
	showQuestion = false;
	showNext = true;
	showBaseline = true;

	chapterIndex = 0;
	questionIndex = 0;

	question_length = 0;
	chapter_name = '';

	currentViewQuestion!: Question;

	constructor(private questionnaireService: QuestionnaireService, private authService: AuthService, private modalService: NgbModal, private translate: TranslateService) {}

	openModal(project_id: number, questionnaire_id: number) {
		this.loading = true;
		this.modalService.open(this.previewQuestionnaireModal, { size: 'xl', backdrop: 'static', keyboard : false });

		this.chapterIndex = 0;
		this.questionIndex = 0;
		this.showQuestion = false;

		this.questionnaireService.getProjectQuestionnaire(project_id, questionnaire_id).subscribe({
			next: (data: Questionnaire) => {
				this.questionnaire = data;
				this.translate.use(this.questionnaire.lang_code);
				this.showDesc = true;
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Getting Questionnaire');
			}
		});
	}

	nextQuestion() {
		if (this.showDesc) {
			this.showDesc = false;
			this.showQuestion = true;
			this.showBaseline = true;

			this.chapter_name = 'baseline';
			this.question_length = this.questionnaire.baseline.baseline_questions.length;
			this.currentViewQuestion = this.questionnaire.baseline.baseline_questions[this.questionIndex];
		} else {
			if (this.showBaseline) {	
				if (this.questionIndex === this.questionnaire.baseline.baseline_questions.length-1) {
					this.questionIndex = 0;
					this.showBaseline = false;
					this.chapter_name = this.questionnaire.chapters[this.chapterIndex].name ? this.questionnaire.chapters[this.chapterIndex].name : 'Chapter-' + (this.chapterIndex+1)
					this.question_length = this.questionnaire.chapters[this.chapterIndex].questions.length;
					this.currentViewQuestion = this.questionnaire.chapters[this.chapterIndex].questions[this.questionIndex];
				} else {
					this.questionIndex++;
					this.currentViewQuestion = this.questionnaire.baseline.baseline_questions[this.questionIndex];
				}
			} else {
				if (this.questionIndex === this.questionnaire.chapters[this.chapterIndex].questions.length-1) {
					this.questionIndex = 0;
					this.chapterIndex++;
					this.chapter_name = this.questionnaire.chapters[this.chapterIndex].name ? this.questionnaire.chapters[this.chapterIndex].name : 'Chapter-' + (this.chapterIndex+1)
					this.question_length = this.questionnaire.chapters[this.chapterIndex].questions.length;
					this.currentViewQuestion = this.questionnaire.chapters[this.chapterIndex].questions[this.questionIndex];
				} else {
					this.questionIndex++;
					this.currentViewQuestion = this.questionnaire.chapters[this.chapterIndex].questions[this.questionIndex];
				}
			}
		}

		if (!this.showBaseline && this.chapterIndex === (this.questionnaire.chapters.length-1) && this.questionIndex === (this.questionnaire.chapters[this.chapterIndex].questions.length-1)) {
			this.showNext = false;
		}
	}

	backQuestion() {
		this.showNext = true;

		if (this.showBaseline) {	
			if (this.questionIndex === 0) {
				this.showDesc = true;
				this.showQuestion = false;
				this.showBaseline = false;
			} else {
				this.questionIndex--;
				this.chapter_name = 'baseline';
				this.question_length = this.questionnaire.baseline.baseline_questions.length;
				this.currentViewQuestion = this.questionnaire.baseline.baseline_questions[this.questionIndex];
			}
		} else {
			if (this.chapterIndex === 0 && this.questionIndex === 0) {
				this.showBaseline = true;
				this.chapter_name = 'baseline';
				this.question_length = this.questionnaire.baseline.baseline_questions.length;
				this.questionIndex = this.questionnaire.baseline.baseline_questions.length-1;
				this.currentViewQuestion = this.questionnaire.baseline.baseline_questions[this.questionIndex];
			} else {
				if (this.questionIndex === 0) {
					this.chapterIndex--;
					this.chapter_name = this.questionnaire.chapters[this.chapterIndex].name ? this.questionnaire.chapters[this.chapterIndex].name : 'Chapter-' + (this.chapterIndex+1)
					this.question_length = this.questionnaire.chapters[this.chapterIndex].questions.length;
					this.questionIndex = this.questionnaire.chapters[this.chapterIndex].questions.length-1;
					this.currentViewQuestion = this.questionnaire.chapters[this.chapterIndex].questions[this.questionIndex];
				} else {
					this.questionIndex--;
					this.currentViewQuestion = this.questionnaire.chapters[this.chapterIndex].questions[this.questionIndex];
				}
			}
		}		
	}
}
